export const onlyDigitsPattern = /^[0-9]\d*$/;
